import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import DisclaimerPopup from "./disclaimerPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { Pagination } from "react-bootstrap";
import { FaDownload, FaRedoAlt } from 'react-icons/fa';
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import jsPDF from "jspdf";
import tmplLogo from "../images/tmplLogo.png";
import "./hm-theme.css";

function EmployeeAppointments() {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  
  const navigate = useNavigate();
  const userid = JSON.parse(localStorage.getItem("data")).userid;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 

  const searchData = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      const searchUrl = `/api/employeeappointment/userid=${userid}`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setAppointmentDetails(response.data);
      // setFilteredData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const trans = await axios.get(`/api/employeeappointment/getAllAppointmentsByUserid/userid=${userid}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      // setFilteredData(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleDownloadReciept = (userid, paymentId) => {
    navigate('/users/payment-receipt', { 
      state: { userid: userid, paymentId:paymentId } 
    });
  };  // const handleCancelAppointment = async (appointmentId) => {
  //   const token = JSON.parse(localStorage.getItem("data")).token;
  //   setLoader(true);
  //   try{
  //     await axios({
  //     url: "/api/employeeappointment/update",
  //     method: "post",
 
  //     headers: { Authorization: `Bearer ${token}` },
 
  //     data: {
  //       id: `${appointmentId}`,
  //       appointmentstatus:"APPOINTMENT CANCELLED"
  //     },
  //   });
  //   toast.success("Appointment Cancelled successfully");
  //     getData();
  //   } catch (error) {
  //     handleError(error);
  //     setLoader(false);
  //   }
  // };

  // const handleBookAppointment = () => {
  //   navigate('/users/book-appointment');
  // };

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/employee-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    axios({
      url: `/api/employee-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
      setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  const handleCancelAppointment = async (appointment) => {
    setSelectedAppointment(appointment)
    setIsCancelPopupOpen(true);
  };
  
  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/employeeappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
    setLoader(false);
      handleError(error);
 
    }
  };

  const handleRetry = async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/re-trigger-api', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Retried successfully');
      getData();
    } catch (error) {
      toast.error('Retry failed');
    } finally {
      setLoader(false); 
    }
  };

  const handleFetchReport= async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
     handleError(error);
    } finally {
      setLoader(false); 
    }
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


 
  return (
    <div>
      <div className="hm-card-header mb-3" style={{ background: "transparent", border: "none", padding: "0 0 0.5rem 0" }}>
        <h4 className="hm-card-title">
          <i className="material-icons">biotech</i>
          Lab Appointments
        </h4>
        <button className="btn-hm-primary" onClick={handleShowImageModal} type="button">
          <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
          Book Appointment
        </button>
      </div>

      <div className="hm-card">
        <div className="hm-card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="hm-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Lab Name</th>
                  <th>Contact</th>
                  <th>Package</th>
                  <th>Status</th>
                  <th>Report</th>
                  <th>Receipt</th>
                  <th>Lab Order</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="9">
                      <div className="hm-empty-state">
                        <i className="material-icons">biotech</i>
                        <p>No lab appointments found</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                      <td>{appointment.date}</td>
                      <td>{appointment.labs?.labname}</td>
                      <td>{appointment.labs?.contact}</td>
                      <td>
                        {appointment.pack !== null && (
                          <div className="d-flex align-items-center gap-2">
                            <span className="hm-badge hm-badge-primary">{appointment.pack?.packagename}</span>
                            <i
                              className="material-icons"
                              style={{ cursor: "pointer", fontSize: "1.1rem", color: "#64748b" }}
                              onClick={() => openTestsModal(appointment.packageid)}
                              title="View Tests"
                            >info</i>
                          </div>
                        )}
                        {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                          <div className="mt-1 text-muted" style={{ fontSize: "0.75rem" }}>
                            + {appointment.additionalTest.length} add-on tests
                          </div>
                        )}
                      </td>
                      <td>
                        <span className={
                          appointment.appStatus?.appointmentStatus?.includes("CANCELLED") ? "hm-badge hm-badge-danger" :
                          appointment.appStatus?.appointmentStatus?.includes("COMPLETED") ? "hm-badge hm-badge-success" :
                          appointment.appStatus?.appointmentStatus?.includes("CONFIRMED") ? "hm-badge hm-badge-info" :
                          "hm-badge hm-badge-warning"
                        }>
                          {appointment.appStatus?.appointmentStatus}
                        </span>
                        {appointment.appStatus?.appointmentStatus !== "APPOINTMENT CANCELLED" &&
                          appointment.appStatus?.appointmentStatus !== "APPOINTMENT COMPLETED" && (
                          <div className="d-flex flex-wrap gap-1 mt-2">
                            {appointment.appStatus?.appointmentStatus === "APPOINTMENT RESCHEDULED" &&
                              appointment.appStatus?.updatedBy !== "Employee" && (
                              <button
                                className="btn btn-success btn-sm rounded-pill px-2"
                                onClick={() => handleAcceptAppointment(appointment.id)}
                              >Accept</button>
                            )}
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-2"
                              onClick={() => handleCancelAppointment(appointment)}
                            >Cancel</button>
                            <button
                              className="btn btn-outline-warning btn-sm rounded-pill px-2"
                              onClick={() => handleRescheduleAppointment(appointment.id)}
                            >Reschedule</button>
                          </div>
                        )}
                      </td>
                      <td>
                        {appointment.appStatus?.appointmentStatus === "APPOINTMENT CANCELLED" ? (
                          <span className="text-muted small">N/A</span>
                        ) : appointment.orderStatus?.appointmentReport ? (
                          appointment.reportstatus === "APPROVED" ? (
                            <a href={appointment.orderStatus.appointmentReport} target="_blank" rel="noopener noreferrer" className="hm-badge hm-badge-success text-decoration-none">
                              View
                            </a>
                          ) : (
                            <span className="hm-badge hm-badge-warning">Pending Approval</span>
                          )
                        ) : appointment.orderStatus ? (
                          <button
                            className="btn btn-outline-primary btn-sm rounded-pill px-2"
                            onClick={() => handleFetchReport(appointment)}
                          >Fetch</button>
                        ) : appointment.reportstatus === "APPROVED" ? (
                          <ul className="list-unstyled mb-0">
                            {(appointment.reports || []).map((report, ri) => (
                              <li key={report.id} className="d-flex align-items-center gap-2 mb-1">
                                <span
                                  className="text-primary"
                                  style={{ cursor: "pointer", fontSize: "0.78rem" }}
                                  onClick={() => handleViewReport(report.id)}
                                >
                                  {report.fileName || `File ${ri + 1}`}
                                </span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <span className="text-muted small">No Report</span>
                        )}
                      </td>
                      <td className="text-center">
                        {appointment.paymentId ? (
                          <button
                            className="btn btn-sm p-1"
                            title="Download Receipt"
                            onClick={() => handleDownloadReciept(appointment.userid, appointment.paymentId)}
                          >
                            <i className="material-icons text-primary" style={{ fontSize: "1.2rem" }}>download</i>
                          </button>
                        ) : (
                          <span className="text-muted small">N/A</span>
                        )}
                      </td>
                      <td>
                        <div>{appointment.orderStatus?.status}</div>
                        {appointment.orderStatus && (
                          (appointment.orderStatus?.orderId === "" || appointment.orderStatus?.orderId == null) &&
                          appointment.appointmentstatus !== "APPOINTMENT CANCELLED" ? (
                            <button
                              className="btn btn-sm btn-outline-danger rounded-pill px-2 mt-1"
                              onClick={() => handleRetry(appointment)}
                            >
                              <i className="material-icons align-middle" style={{ fontSize: "0.9rem" }}>refresh</i> Retry
                            </button>
                          ) : (
                            <code style={{ fontSize: "0.76rem" }}>{appointment.orderStatus?.orderId}</code>
                          )
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center py-3">
              <ul className="pagination hm-pagination mb-0">
                <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(0)}>«</button>
                </li>
                <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>‹</button>
                </li>
                {renderPageNumbers()}
                <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>›</button>
                </li>
                <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => handlePageChange(totalPages - 1)}>»</button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={closeTestsModal}
          packageId={selectedPackage}
        />
      )}

      {showImageModal && (
        <DisclaimerPopup isOpen={showImageModal} onRequestClose={handleCloseImageModal} userid={userid} />
      )}

      {isReschedulePopupOpen && (
        <AppointmentReschedule
          isOpen={isReschedulePopupOpen}
          onRequestClose={handleCloseReschedulePopup}
          appointmentId={selectedAppointmentId}
        />
      )}

      {isCancelPopupOpen && (
        <FamilyAppointmentCancel
          isOpen={isCancelPopupOpen}
          onRequestClose={handleCloseCancelPopup}
          appointment={selectedAppointment}
        />
      )}

      {loader && <div className="loading"></div>}
    </div>
  );
}

export default EmployeeAppointments;